import React, { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import axios from "axios";
import { ENDPOINTS } from "../../js/api/_config";
import SecondaryButton from "../common/buttons/SecondaryButton";

import { IconToggle } from "../../assets/icons/icon-toggle-chat";
import PatientJourney from "./patient-journey";
import { IconSend } from "../../assets/icons/icon-send";
import { IconToggleClose } from "../../assets/icons/icon-toggle-chat-close";

import { fetchUserProfile } from "../../reducer/slices/user/userSlice";
import { useDispatch, useSelector } from "react-redux";
import NoConversation from "../../assets/images/no-conversation-vector.svg";
import {
  convertTimeToLocation,
  getBrowserTimeZone,
} from "../common/constant/constant";
import AddEventContainer from "./add-event/add-event-container";
import { getRecruiterLists } from "../../reducer/slices/recruiter/get-recruiter-slice";
import { getWorkflowTrialById } from "../../reducer/slices/workflow/get-workflow-by-id";
import { Toast } from "../common/toast/toast";
import { getTrialById } from "../../js/api/events";
import { CallIcon } from "../../assets/icons/call-icon";
import { CallIconHover } from "../../assets/icons/call-icon-hover";
import { AddNotesHoverIcon } from "../../assets/icons/add-notes-hover";
import { AddNotesIcon } from "../../assets/icons/add-notes";
import { AddEventsHoverIcon } from "../../assets/icons/add-events-hover";
import { AddEventsIcon } from "../../assets/icons/add-events";
import { IconToggleHover } from "../../assets/icons/icon-toggle-chat-hover";
import { IconToggleCloseHover } from "../../assets/icons/icon-toggle-chat-close-hover";
import CallSuccessNotice from "./call-log/call-success-notice";
import MissedCallNotice from "./call-log/missed-call-notice";
import Docusing from "../../assets/icons/docusing";
import {
  docuSignStatusClass,
  docuSingStatusMapping,
} from "../../js/api/constants";
import Modal from "../common/modal/modal";
import DocuSingDeliver from "../../assets/icons/docusing-deliver";
import DocuSingSent from "../../assets/icons/docusing-sent";
import { CallCalendarIcon } from "../../assets/icons/call-icon-calendar";
import StatusPatientChange from "../conversations/status-change-patient";
import AllowedAccess from "../../guards/AllowedAccess";
import PermissionList from "../../guards/PermissionList";

const statusClasses = {
  All: "bg-[#536493]",
  "In Progress": "bg-[#6F6EDE]",
  "Action Required": "bg-[#F26666]",
  "Requested Follow Up": "bg-[#FABC3F]",
  Qualified: "bg-[#15B392]",
  Booked: "bg-[#66D062]",
  "DNQ Criteria Not Met": "bg-[#CBA35C]",
  "DNQ Other": "bg-[#CBA35C]",
  "DNQ No Response": "bg-[#CBA35C]",
  "DNQ Not Interested": "bg-[#CBA35C]",
  "Non-textable": "bg-[#D73A60]",
  "To-call": "bg-[#605EA1]",
  "Contact Attempt 1": "bg-[#F28E58]",
  "Contact Attempt 2": "bg-[#F28E58]",
  "Contact Attempt 3": "bg-[#F28E58]",
  "Scheduled Screen": "bg-[#AA5486]",
};

const RightComponent = ({
  trialInfo,
  conversation,
  id,
  setLatestmessage,
  onMessageSend,
  handleCall,
}) => {
  const [toasts, setToasts] = useState([]);
  const formatTime = (timeString) => {
    const formattedTime = dayjs(timeString).format("MM/DD [at] hh:mm A");
    return formattedTime;
  };
  const isCallInProgress = useSelector((state) => state.call.callData);
  const callViewSize = useSelector((state) => state.callView.callSizeData);
  // const recruiterData = useSelector(state => state.recruiter_list?.data || {});
  const chatContainerRef = useRef(null);
  const [isAtBottom, setIsAtBottom] = useState(true);
  const [isAgentOn, setIsAgentOn] = useState(false);
  const [isCallHover, setIsCallHover] = useState(false);
  const [getAllTStatus, setGetAllTStatus] = useState([]);
  const [isNoteHover, setIsNoteHover] = useState(false);
  const [isEventHover, setIsEventHover] = useState(false);
  const [isDocuSingModalOpen, setIsDocuSingModalOpen] = useState(false);
  const [isDocuSingLoader, setIsDocuSingLoader] = useState(false);
  const [isCalenderRecriuterLoading, setIsCalenderRecriuterLoading] =
    useState(true);
  const { userProfile, isLoading } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const formatTimelocaltime = (timeString) => {
    const date = new Date(timeString); // Input is expected to be in UTC
    const timeZone = getBrowserTimeZone();
    const options = {
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone, // Force UTC
    };

    const formatter = new Intl.DateTimeFormat("en-US", options);
    const parts = formatter.formatToParts(date);

    const month = parts.find((p) => p.type === "month").value;
    const day = parts.find((p) => p.type === "day").value;
    const hour = parts.find((p) => p.type === "hour").value;
    const minute = parts.find((p) => p.type === "minute").value;
    const period = parts.find((p) => p.type === "dayPeriod").value;

    return `${month}/${day} at ${hour}:${minute} ${period}`;
  };

  useEffect(() => {
    dispatch(fetchUserProfile({}));
    dispatch(getRecruiterLists({}));
  }, []);

  useEffect(() => {
    if (trialInfo) {
      const id = trialInfo.trialID;
      dispatch(getWorkflowTrialById({ id }));
    }
  }, [trialInfo]);

  const message = {
    recruiterName: `${userProfile.firstName} ${userProfile.lastName}`,
  };

  const [chatMessages, setChatMessages] = useState([]);

  useEffect(() => {
    // Initialize chatMessages from conversation on first load
    if (conversation && conversation.length > 0) {
      setChatMessages([...conversation]);
    }
  }, [conversation]);

  // useEffect(() => {
  //   if (chatContainerRef.current) {
  //     chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
  //   }
  // }, [chatMessages]);

  // Function to scroll smoothly to the bottom
  const scrollToBottom = () => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTo({
        top: chatContainerRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  };

  // Check if user is at the bottom of the chat
  const handleScroll = () => {
    if (chatContainerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } =
        chatContainerRef.current;
      setIsAtBottom(scrollTop + clientHeight >= scrollHeight - 10);
    }
  };

  // Auto-scroll only if the user is at the bottom
  useEffect(() => {
    if (isAtBottom) {
      scrollToBottom();
    }
  }, [chatMessages]); // Runs only when messages update

  const [isOpen, setIsOpen] = useState(false);
  const [isAddEventOpen, setIsAddEventOpen] = useState(false);
  const [addEventId, setAddEventId] = useState(false);
  // const trialRecruiter = useSelector(state => state.workflow_by_trial_id.data);
  const [trialRecruiter, setTrialRecruiter] = useState(null);
  const [recruiterData, setRecruiterData] = useState(
    trialRecruiter &&
    trialRecruiter.assignedRecruiter &&
    trialRecruiter.assignedRecruiter.filter((val) => val.hasCalendar)
  );
  const [operationalData, setOperationalData] = useState(
    trialRecruiter &&
    trialRecruiter.operatingHoursJson &&
    trialRecruiter.operatingHoursJson
  );
  const hasFetchedTrialRef = useRef(false);

  const AddNote = () => {
    setIsOpen(!isOpen);
  };
  const closePopup = () => {
    setIsOpen(false);
  };
  const openAddEvent = () => {
    setAddEventId(trialInfo.trialID);

    setTimeout(() => {
      setIsAddEventOpen(!isOpen);
    }, 500);

    console.log("trialInfo", trialInfo);
  };
  const closeAddEvent = () => {
    setIsAddEventOpen(false);
  };

  const [text, setText] = useState("");

  const handleNoteChange = (e) => {
    if (e.target.value.length <= 500) {
      setText(e.target.value);
    }
  };

  const fetchTrialDataByIdFunc = (id) => {
    if (hasFetchedTrialRef.current) return;

    // Basic condition check
    if (
      !trialRecruiter ||
      (recruiterData && !recruiterData.length) ||
      (operationalData && operationalData.length)
    ) {
      setIsCalenderRecriuterLoading(true);
    }

    getTrialById({ id })
      .then((trial) => {
        console.log("Fetched trial: 1", trial.data);
        setTrialRecruiter(trial.data);
        setRecruiterData(
          trial?.data?.assignedRecruiter?.filter((val) => val.hasCalendar)
        );
        setOperationalData(trial?.data?.operatingHoursJson);
        setIsCalenderRecriuterLoading(false);
        hasFetchedTrialRef.current = true; // Mark as fetched
      })
      .catch((err) => {
        setIsCalenderRecriuterLoading(false);
        console.error("Failed to fetch trial:", err);
      });
  };

  const getAllTrialStatus = async () => {
    const response = await axios
      .get(ENDPOINTS.TRIALS.GET_ALL_TRIAL_STATUS)
      .then((res) => {
        setGetAllTStatus(res.data.data.items);
      });
  };

  const updateTrialStatus = async (value) => {
    try {
      const response = await axios.put(
        `${ENDPOINTS.TRIALS.CHANGE_PATIENT_STATUS}?patientTrialJuncId=${trialInfo.patientTrialJuncID}&statusName=${value.normalizedStatus}`
      );
    } catch (error) {
      if (
        error &&
        error.response &&
        error.response.data &&
        typeof error.response.data.message === "string"
      ) {
        addToast(error.response.data.message, "error");
      }
    }
  }

  useEffect(() => {
    console.log("trialInfo", trialInfo);
    const id = addEventId;
    console.log("Fetched trial: 1", id);
    fetchTrialDataByIdFunc(id);
    getAllTrialStatus();
  }, []);

  useEffect(() => {
    console.log("trialInfo", trialInfo);
    const id = addEventId;
    console.log("Fetched trial: 1", id);
    fetchTrialDataByIdFunc(id);
  }, [addEventId]);

  // useEffect(() => {
  //   console.log('trialInfo', trialInfo)
  //   const id = addEventId;
  //   console.log('trialInfo', trialInfo)
  //   // dispatch(getWorkflowTrialById({ id }))
  //   getTrialById({ id })
  // .then(trial => {
  //   // Do something with the trial data
  //   console.log('Fetched trial:', trial);
  // })
  // .catch(err => {
  //   // Handle error
  //   console.error('Failed to fetch trial:', err);
  // });
  // }, [addEventId]);

  //const phoneNumber = data.phoneNumber;

  // to get time

  const getCurrentTime = () => {
    const now = new Date();
    console.log("from function time value", now.toISOString());
    return now.toISOString();
  };

  const [recMessage, setRecMessage] = useState("");

  const sendMessage = async () => {
    const currentTime = getCurrentTime();
    console.log("currentTime => ", currentTime);

    const result = {
      userMessage: recMessage,
      toPhoneNumber: trialInfo.phoneNumber,
      sessionId: trialInfo.patientTrialJuncID,
    };

    try {
      const response = await axios.post(
        ENDPOINTS.CONVERSATION.SEND_MESSAGE,
        result
      );

      setRecMessage("");

      if (response.status === 200) {
        const sentMessage = {
          msgContent: recMessage,
          lastContacted: currentTime,
          messageAt: currentTime,
          recruiterName: `${userProfile.firstName} ${userProfile.lastName}`,
        };

        if (setLatestmessage) {
          setLatestmessage(sentMessage);
        }
        if (onMessageSend) {
          onMessageSend();
        }

        setChatMessages((prevMsg) => [...prevMsg, sentMessage]);
      } else {
        console.error("Error sending message:", response.statusText);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      sendMessage();
    }
  };

  const AddNoteToChat = async (e) => {
    const currentTime = getCurrentTime();
    try {
      const response = await axios.post(
        `${ENDPOINTS.CONVERSATION.ADD_NOTE}?patientTrialJuncId=${id}&note=${text}`
      );

      if (response.status === 200) {
        const addNote = {
          msgContent: text,
          sender: "NoteRecruiter",
          recruiterName: `${userProfile.firstName} ${userProfile.lastName}`,
          createdAt: currentTime,
          lastContacted: currentTime,
        };
        console.log("addNote => ", addNote);
        setText("");
        setIsOpen(false);
        setChatMessages((prevMsg) => [...prevMsg, addNote]);
        console.log("chatMessages updated:", chatMessages);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const [togglePj, setTogglePj] = useState(true);
  const [togglePjHover, setTogglePjHover] = useState(false);
  // get initials
  const getInitials = (name) => {
    if (!name || typeof name !== "string") return "";

    const words = name
      .trim()
      .replace(/\s+/g, " ") // Replace multiple spaces with single space
      .split(" ") // Split into words
      .filter((word) => word.length > 0); // Filter out empty strings

    const initials = words.slice(0, 2).map((word) => {
      if (word && word.length > 0) {
        return word[0].toUpperCase();
      }
      return "";
    });

    return initials.join("");
  };
  // get initials Ends -------------------------

  const truncate = (text = "", limit = 0) => {
    if (typeof text !== "string") return "";
    return text.length > limit ? text.slice(0, limit).trimEnd() + "..." : text;
  };


  const addToast = (message, type) => {
    const id = Date.now();
    setToasts([...toasts, { id, message, type }]);
    setTimeout(() => removeToast(id), 3000);
  };

  const removeToast = (id) => {
    setToasts(toasts.filter((toast) => toast.id !== id));
  };

  useEffect(() => {
    setIsAgentOn(trialInfo?.isChatByBot === "True" ? true : false);
  }, [trialInfo]);

  const updateAgentControl = async (value) => {
    let queryParams = {
      patientTrialJuncId: id,
      isChatByBot: value,
    };

    await axios
      .put(
        ENDPOINTS.CONVERSATION.UPDATE_PATIENT_CONVERSATION_CONTROL,
        {},
        { params: queryParams }
      )
      .then((res) => {
        // handle success
      });
  };

  const sendDocument = async () => {
    let params = {
      patientID: trialInfo.patientID,
    };

    setIsDocuSingLoader(true);
    await axios
      .post(ENDPOINTS.DOCUSIGN.SEND_DOCUMENT, params)
      .then((res) => {
        console.log("res.data.data", res.data.data);
        addToast(
          res.data.data.message,
          res.data.data.isSuccess ? "success" : "error"
        );
      })
      .finally(() => {
        setIsDocuSingModalOpen(false);
        setIsDocuSingLoader(false);
      });
  };

  const handleDocuSingaction = () => {
    setIsDocuSingModalOpen(true);
  };

  const NoteRecruiterMessage = ({ message }) => (
    <div className="flex justify-end mb-4 text-right">
      <div className="w-auto">
        <div className="flex justify-end items-center">
          <span className="text-[16px] font-medium px-3 py-2 text_color">
            {message.recruiterName || "AI Assistant"}
          </span>
        </div>
        <div
          className="text-[14px] text-left p-2 bg-[#FFF7DD] border rounded-lg text_color"
          style={{ borderColor: "#FFC95C" }}
        >
          <span className="font-medium">Note: </span>
          <span>{message.msgContent}</span>
        </div>
        <span className="text-xs text-right text-[#667783] py-3 block">
          {message.condition
            ? formatTimelocaltime(message.createdAt)
            : formatTime(convertTimeToLocation(message.createdAt))}
        </span>
      </div>
    </div>
  );

  const DocuSignMessage = ({ message }) => (
    <div className="flex justify-end mb-4 text-right">
      <div className="max-w-lg">
        <div className="flex justify-end items-center">
          <span className="text-[16px] font-medium px-3 py-2 text_color">
            {message.recruiterName || "Epic Medical Research"}
          </span>
        </div>
        <div
          className="text-[14px] text-left p-2 bg-[#dde9ff] border rounded-lg text_color"
          style={{ borderColor: "#5d76e2" }}
        >
          <span className="font-medium">{message.msgContent}</span>
        </div>
        <span className="text-xs text-right text-[#667783] py-3 block">
          {message.condition
            ? formatTimelocaltime(message.createdAt)
            : formatTime(convertTimeToLocation(message.createdAt))}
        </span>
      </div>
    </div>
  );

  const PatientMessage = ({ message, patientName }) => (
    <div className="flex justify-start mb-4">
      <div className="max-w-lg" style={{ borderColor: "#E7E7E7" }}>
        <p className="text-[16px] font-medium text_color px-3 py-2 text-left">
          {patientName}
        </p>
        <p
          className="text-[16px] py-[16px] px-[24px] bg-white border"
          style={{ borderRadius: "0 14px 14px 14px", borderColor: "#E7E7E7" }}
        >
          {message.msgContent}
        </p>
        <span className="text-xs text-[#667783] p-3 block text-left">
          {message.condition
            ? formatTimelocaltime(message.createdAt)
            : formatTime(convertTimeToLocation(message.createdAt))}
        </span>
      </div>
    </div>
  );

  const GenericMessage = ({ message }) => (
    <div className="flex justify-end mb-4">
      <div className="max-w-lg">
        <p className="text-[16px] font-medium text_color px-3 py-2 text-right">
          {message.recruiterName || "AI Assistant"}
        </p>
        <p
          className="text-[16px] py-[16px] px-[24px] bg-[#278EFF] text-white"
          style={{ borderRadius: "14px 0 14px 14px" }}
        >
          {message.msgContent}
        </p>
        <span className="text-xs text-[#667783] p-3 block text-right">
          {message.condition
            ? formatTimelocaltime(message.createdAt)
            : formatTime(convertTimeToLocation(message.createdAt))}
        </span>
      </div>
    </div>
  );

  useEffect(() => {
    console.log("isCallInProgress", isCallInProgress);
    console.log("isCallInProgress 2", callViewSize);
    if (isCallInProgress && !callViewSize.isMinView) {
      setIsAddEventOpen(false)
    }
  }, [callViewSize]);

  return conversation && chatMessages.length === 0 ? (
    <div
      className="chat-body h-[calc(100vh-80px)] w-full flex flex-col items-center justify-center no-conversation actual-img-ratio border-l bg-[#ffffff]"
      style={{ borderColor: "#C8D6E6" }}
    >
      <img src={NoConversation} alt="" />
      <p className="mt-1 text-sm font-medium">No Conversations yet</p>
    </div>
  ) : (
    <>
      <div
        className="flex-1 flex flex-col border-l overflow-hidden"
        style={{ borderColor: "#C8D6E6" }}
      >
        {/* Header */}
        {toasts.map((toast) => (
          <Toast
            key={toast.id}
            toast={toast}
            onClose={() => removeToast(toast.id)}
          />
        ))}
        <div
          className="chat-body flex items-center justify-between p-4 bg-white border-b"
          style={{ borderColor: "#C8D6E6" }}
        >
          <div className="flex items-center space-x-2 w-full justify-between">
            <p className="text-left flex items-center justify-between">
              <span className="recruiter-intials">
                {trialInfo?.patientName && getInitials(trialInfo?.patientName)}
              </span>
              <span className="font-semibold ml-[13px] text-[20px] title_color whitespace-nowrap">
                {trialInfo?.patientName} -{" "}
              </span>{" "}
              <span className="text-[18px] text_color pl-[5px]">
                {trialInfo?.phoneNumber}
              </span>
              {trialInfo?.docuSignStatus === "recipient-completed" && (
                <>
                  &nbsp;&nbsp;&nbsp;
                  <svg
                    width="26"
                    height="26"
                    viewBox="0 0 26 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.62006 3.30203C10.5905 0.232657 15.4095 0.232657 16.3799 3.30203C16.9005 4.94853 18.7745 5.92516 20.6145 5.50885C24.0445 4.73277 26.454 8.49989 23.9944 10.7932C22.675 12.0234 22.675 13.9766 23.9944 15.2068C26.454 17.5001 24.0445 21.2672 20.6145 20.4912C18.7745 20.0748 16.9005 21.0515 16.3799 22.698C15.4095 25.7673 10.5905 25.7673 9.62006 22.698C9.0995 21.0515 7.22549 20.0748 5.38552 20.4912C1.95548 21.2672 -0.454034 17.5001 2.00558 15.2068C3.32499 13.9766 3.32499 12.0234 2.00558 10.7932C-0.454033 8.49989 1.95548 4.73277 5.38552 5.50885C7.22549 5.92516 9.0995 4.94853 9.62006 3.30203Z"
                      fill="#16C47F"
                    />
                    <path
                      d="M17.7552 9.78078L13.6377 14.2408C12.7912 15.1577 12.368 15.6161 11.8112 15.6161C11.2544 15.6161 10.8312 15.1577 9.98468 14.2408L8.2448 12.3562M5.38552 5.50885C7.22549 5.92516 9.0995 4.94853 9.62006 3.30203C10.5905 0.232657 15.4095 0.232657 16.3799 3.30203C16.9005 4.94853 18.7745 5.92516 20.6145 5.50885C24.0445 4.73277 26.454 8.49989 23.9944 10.7932C22.675 12.0234 22.675 13.9766 23.9944 15.2068C26.454 17.5001 24.0445 21.2672 20.6145 20.4912C18.7745 20.0748 16.9005 21.0515 16.3799 22.698C15.4095 25.7673 10.5905 25.7673 9.62006 22.698C9.0995 21.0515 7.22549 20.0748 5.38552 20.4912C1.95548 21.2672 -0.454034 17.5001 2.00558 15.2068C3.32499 13.9766 3.32499 12.0234 2.00558 10.7932C-0.454033 8.49989 1.95548 4.73277 5.38552 5.50885Z"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                  </svg>
                </>
              )}
            </p>
            <div className="text-right flex justify-end relative items-center">
              <div className="relative group inline-block items-center flex border-r pr-4" style={{ borderColor: "#e3eaf2" }}>
                <button
                  disabled={isCallInProgress}
                  onClick={() => {
                    handleCall(trialInfo.phoneNumber);
                  }}
                  className={
                    isCallInProgress ? `cursor-not-allowed p-0` : `p-0`
                  }
                  onMouseEnter={() => setIsCallHover(true)}
                  onMouseLeave={() => setIsCallHover(false)}
                >
                  {/* {isCallHover ? <CallIconHover /> : <CallIcon />} */}
                  <CallCalendarIcon />
                </button>

                {/* Tooltip */}
                <div
                  className="absolute top-full left-1/2 -translate-x-1/2 mt-2 
                opacity-0 group-hover:opacity-100 transition-opacity duration-200 
                bg-white text-[#1A1A1B] border border-[#E4E4E4] 
                text-xs px-2 py-1 rounded z-50 whitespace-nowrap 
                w-[42px] h-[32px] flex items-center justify-center tooltip"
                >
                  {isCallInProgress ? "Call In Progress" : "Call"}
                </div>
              </div>
              {/* <div className="border-r mx-4 border-[#C8D6E6] "></div>
              <p
                className="mr-4 border-r pr-4 text-[16px]  border-[#C8D6E6]"
                // style={{ borderColor: "#e3eaf2" }}
              >
                <span className="font-semibold">Trial: </span>
                {trialInfo?.trialName && truncate(trialInfo?.trialName, 30)}
                {trialInfo?.status && (
                  <span
                    className={`text-xs text-gray-500 rounded-3xl px-2 ml-[12px] py-2 status-bubble ${
                      statusClasses[trialInfo?.status] || "bg-gray-200"
                    }`}
                  >
                    {trialInfo?.status}
                  </span>
                )}
              </p> */}

              <div className="mr-4 border-r pr-4 text-[16px]" style={{ borderColor: "#e3eaf2" }}>
                <div class="relative inline-block text-left mr-3">
                  <StatusPatientChange
                    className={'absolute top-[35px] left-[-20px]'}
                    options={getAllTStatus}
                    initialValue={trialInfo?.status}
                    onSelect={(selectedOption) => {
                      console.log('selectedOption', selectedOption);
                      updateTrialStatus(selectedOption);
                    }}
                  />
                </div>
                <span><span className="font-medium">On</span> 01/09 <span className="font-medium">at</span> 10:30 AM</span>
              </div>

              <div className="relative group group-icon mr-4 border-r pr-4 border-[#C8D6E6]">
                <label
                  className={`text-[16px] relative inline-flex items-center h-6 w-12 rounded-full cursor-pointer border border-[#A6A6A6] ${isAgentOn ? "bg-blue-500 border-blue-500" : "bg-[#ffffff]"
                    }`}
                >
                  <input
                    type="checkbox"
                    checked={isAgentOn}
                    className="hidden"
                    onChange={(e) => {
                      setIsAgentOn(!isAgentOn);
                      updateAgentControl(!isAgentOn);
                    }}
                  />
                  <span
                    className={`inline-block h-[18px] w-[18px] bg-[#A6A6A6] rounded-full transform transition-transform ${isAgentOn ? "translate-x-6 bg-white" : "translate-x-1"
                      }`}
                  ></span>
                </label>
                <span className="tooltip bottom-full transform -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity">
                  {isAgentOn ? "Off" : "On"} AI Assistance
                </span>
              </div>
              <AllowedAccess permissions={[PermissionList.conversations.chat_details]}>
                <div className="relative group group-icon">
                  <span
                    className={
                      togglePj
                        ? "expandPf cursor-pointer"
                        : "collapsePf cursor-pointer"
                    }
                    onClick={() => setTogglePj(!togglePj)}
                    onMouseEnter={() => {
                      setTogglePjHover(true);
                    }}
                    onMouseLeave={() => {
                      setTogglePjHover(false);
                    }}
                  >
                    {togglePj ? (
                      togglePjHover ? (
                        <IconToggleHover />
                      ) : (
                        <IconToggle />
                      )
                    ) : togglePjHover ? (
                      <IconToggleCloseHover />
                    ) : (
                      <IconToggleClose />
                    )}
                  </span>
                  <span className="tooltip bottom-full transform -translate-x-full opacity-0 group-hover:opacity-100 transition-opacity">
                    Chat Details
                  </span>
                </div>
              </AllowedAccess>

            </div>
          </div>
        </div>
        <div className="chatBodyPart flex justify-between flex-row bg-[#F5F5F5]  h-[calc(100vh-155px)]">
          <div className="chatBodyLeft flex flex-col h-full w-full">
            {/* Chat Messages */}
            <div
              className="flex-1 overflow-y-auto p-4"
              id="liveChatMessages"
              ref={chatContainerRef}
              onScroll={handleScroll}
            >
              {chatMessages?.map((message, index) => {
                if (message.sender === "NoteRecruiter") {
                  return <NoteRecruiterMessage key={index} message={message} />;
                } else if (message.sender === "DocuSign") {
                  return (
                    <DocuSignMessage
                      key={index}
                      message={message}
                      patientName={trialInfo.patientName}
                    />
                  );
                } else if (message.sender === "Patient") {
                  return (
                    <PatientMessage
                      key={index}
                      message={message}
                      patientName={trialInfo.patientName}
                    />
                  );
                } else if (message.sender === "CallLog") {
                  const msgContent = JSON.parse(message.msgContent);
                  const isCompleted = msgContent.CallStatus === "completed";
                  const isMissedCall = msgContent.CallStatus === "no-answer";
                  return (
                    <div className="flex justify-end mb-4">
                      {isCompleted ? (
                        <CallSuccessNotice msgContent={msgContent} />
                      ) : isMissedCall ? (
                        <MissedCallNotice msgContent={msgContent} />
                      ) : (
                        ""
                      )}
                    </div>
                  );
                } else {
                  return <GenericMessage key={index} message={message} />;
                }
              })}
            </div>

            {/* Message Input */}
            <div
              className="p-4 bg-[#f5f5f5] flex items-center h-[80px]"
              style={{ borderColor: "#C8D6E6" }}
            >
              <div
                className="bg-white w-full flex justify-end p-3 border rounded-lg"
                style={{ borderColor: "#C8D6E6" }}
              >
                <AllowedAccess permissions={[PermissionList.conversations.outbound_conversation]}>
                  <textarea
                    placeholder="Type a message"
                    className="w-full border-none outline-none p-2 text-[16px] text-[#87909e] resize-none overflow-hidden leading-tight"
                    value={recMessage}
                    rows={2}
                    style={{
                      height: "40px", // Adjust as per design needs
                      lineHeight: "20px", // Ensure two lines fit within height
                      paddingTop: "6px",
                      paddingBottom: "2px",
                      overflowY: "hidden", // Hide extra content
                      display: "block",
                    }}
                    onChange={(e) => setRecMessage(e.target.value)}
                    onKeyDown={handleKeyDown}
                    onInput={(e) => {
                      const target = e.target;
                      target.scrollTop = target.scrollHeight; // Ensures last lines stay visible
                    }}
                  />
                  <button
                    className="ml-2 pr-2 pl-1 py-2 bg_blue_color text-white h-[46px] w-[46px] rounded-3xl"
                    onClick={sendMessage}
                  >
                    <span className="-rotate-[5deg] block">
                      <IconSend />
                    </span>
                  </button>
                  <span className="border-r table_border h-[46px] mx-[22px]"></span>
                </AllowedAccess>

                <div className="flex py-1">
                  {/* Add Note Button */}
                  <AllowedAccess permissions={[PermissionList.conversations.conversation_note]}>
                    <div className="relative group">
                      <button
                        className="inline-flex items-center py-1 gap-2 text-[14px] font-[500] text-[#1a1a1b] shadow-sm"
                        onClick={AddNote}
                        onMouseEnter={() => setIsNoteHover(true)}
                        onMouseLeave={() => setIsNoteHover(false)}
                      >
                        {isNoteHover ? <AddNotesHoverIcon /> : <AddNotesIcon />}
                      </button>
                      <span className="absolute -top-10 left-1/2 -translate-x-1/2 w-[76px] h-[30px] whitespace-nowrap px-2 py-[2px] text-[10px] text-center text-black bg-white border border-gray-300 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10  font-semibold">
                        <div className="mt-1">Add Note</div>
                      </span>
                    </div>
                  </AllowedAccess>


                  {/* Add Event Button */}
                  <AllowedAccess permissions={[PermissionList.conversations.add_event_to_conversation]}>
                    <div className="relative group ml-[20px]">
                      <button
                        className="inline-flex items-center py-1 gap-2 rounded-md text-[14px] font-[500]"
                        onClick={openAddEvent}
                        onMouseEnter={() => setIsEventHover(true)}
                        onMouseLeave={() => setIsEventHover(false)}
                      >
                        {isEventHover ? (
                          <AddEventsHoverIcon />
                        ) : (
                          <AddEventsIcon />
                        )}
                      </button>
                      <span className="absolute -top-10 left-1/2 -translate-x-1/2 w-[90px] h-[30px] whitespace-nowrap px-2 py-[2px] text-[10px] text-center mt-auto text-black bg-white border border-gray-300 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10  font-semibold">
                        <div className="mt-1">Add Event</div>
                      </span>
                    </div>
                  </AllowedAccess>


                  <div className="relative group ml-[20px]">
                    <button
                      className="inline-flex items-center py-1 gap-2 rounded-md text-[14px] font-[500]"
                      onClick={handleDocuSingaction}
                    >
                      <Docusing />
                    </button>
                    <span className="absolute -top-10 left-1/2 -translate-x-3/4 w-[120-px] h-[30px] whitespace-nowrap px-2 py-[2px] text-[10px] text-center mt-auto text-black bg-white border border-gray-300 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10 font-semibold">
                      <div className="mt-1">Send DocuSign Link</div>
                    </span>
                  </div>
                </div>
                {isAddEventOpen && (
                  <AddEventContainer
                    isCalenderRecriuterLoading={isCalenderRecriuterLoading}
                    recruiterData={recruiterData}
                    operationalData={operationalData}
                    trialRecruiter={trialRecruiter}
                    trialInfo={trialInfo}
                    isAddEventOpen={isAddEventOpen}
                    openAddEvent={openAddEvent}
                    closeAddEvent={closeAddEvent}
                    toasts={toasts}
                    removeToast={removeToast}
                    setToasts={setToasts}
                  />
                )}
              </div>
            </div>
          </div>
          <AllowedAccess permissions={[PermissionList.conversations.chat_details]}>
            <div
              className={`chatBodyright transition-all ${togglePj ? "block" : "hidden"
                }`}
            >
              <PatientJourney trialInfo={trialInfo} setTogglePj={setTogglePj} />
            </div>
          </AllowedAccess>

        </div>

        {/* popup for Add Note */}
        {isOpen && (
          <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg max-w-md w-full p-6 relative">
              <h2>Add Note</h2>
              <textarea
                className="field_bg border_color border text-base rounded-lg block w-full p-2.5 mt-5 h-40"
                onChange={handleNoteChange}
                placeholder="Type your text here..."
              ></textarea>
              <div className="mt-2 text-sm w-full text-gray-600">
                {text.length} / 500
              </div>
              <button
                onClick={closePopup}
                className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
              >
                ✕
              </button>
              <div className="flex justify-end">
                <button
                  onClick={AddNoteToChat}
                  className="px-5 mr-3 py-1 text-base rounded-md border primary_btn transition-all duration-500"
                >
                  Save
                </button>
                <SecondaryButton onClick={closePopup} label="Cancel" />
              </div>
            </div>
          </div>
        )}
      </div>

      <Modal
        isOpen={isDocuSingModalOpen}
        onClose={() => { }}
        width={trialInfo.docuSignStatus != null ? "max-w-xl" : "max-w-lg"}
      //title="Sample Modal"
      >
        {trialInfo.docuSignStatus == null && (
          <>
            <div className="flex justify-between gap-4">
              <div>
                <div className="w-[45px] h-[45px] rounded-full overflow-hidden flex items-center justify-center bg-[#F1EBFF]">
                  <Docusing />
                </div>
              </div>

              <p className="font-medium">
                Are you sure you want to send and make this Docusing document
                public to the recipent?
              </p>
            </div>

            <div className="mt-6 flex justify-end space-x-2">
              <button
                disabled={isDocuSingLoader}
                onClick={sendDocument}
                className="px-5 py-1 text-base rounded-md border primary_btn transition-all duration-500 min-w-[94px]"
              >
                {isDocuSingLoader ? (
                  <div className="flex justify-center">
                    <div className="mini-spinner "></div>
                  </div>
                ) : (
                  "Send"
                )}
              </button>

              <button
                disabled={isDocuSingLoader}
                onClick={() => setIsDocuSingModalOpen(false)}
                className={`px-[20px] py-[10px] text-[14px] font-medium rounded-md border secondary_btn transition-all duration-500`}
              >
                Cancel
              </button>
            </div>
          </>
        )}

        {trialInfo.docuSignStatus != null && (
          <>
            <div className="flex justify-between gap-4">
              <div>
                <div className="w-[50px] h-[50px] rounded-full overflow-hidden flex items-center justify-center bg-[#F1EBFF]">
                  <Docusing />
                </div>
              </div>
              <div>

                <p className="font-medium">The current document status in DocuSign is
                  '{docuSingStatusMapping[trialInfo.docuSignStatus]}' -
                  {docuSingStatusMapping[trialInfo.docuSignStatus] == "Document Signed" && " Signature received from the recipient."}
                  {docuSingStatusMapping[trialInfo.docuSignStatus] == "Document Delivered" && " Document viewed by recipient."}
                  {docuSingStatusMapping[trialInfo.docuSignStatus] == "Document Sent" && " Document sent to the Patient."}
                </p>

                <p className={`text-xs mt-2 text-gray-500 rounded-3xl px-2 py-2 status-bubble inline-flex gap-2 
                  ${docuSignStatusClass[trialInfo.docuSignStatus]}`}>
                  {docuSingStatusMapping[trialInfo.docuSignStatus] == "Document Delivered" && <DocuSingDeliver />}
                  {docuSingStatusMapping[trialInfo.docuSignStatus] == "Document Sent" && <DocuSingSent />}

                  {docuSingStatusMapping[trialInfo.docuSignStatus]}
                </p>
              </div>
            </div>
            <div className="mt-6 flex justify-end space-x-2">
              <button
                onClick={() => setIsDocuSingModalOpen(false)}
                className="px-[20px] py-[10px] text-[14px] text-base rounded-md border primary_btn transition-all duration-500 min-w-[94px]"
              >
                OK
              </button>
            </div>
          </>
        )}
      </Modal>
    </>
  );
};

export default RightComponent;
